import axios from 'axios';

import { toast } from 'react-toastify';

export default class ApiBase {

    constructor(url = '/api/connector/call') {
        this.defaultError = 'System Error';
        this.url = url;
        this.defaultValidationHandler = errors => {
            console.error(errors)
        }
    }


    handleError(error = this.defaultError) {
        throw new Error(error);
    }

    call(method, path, params, validationCallback = this.defaultValidationHandler, shouldReport) {
        return this.handleResponse(
            () => {
                return axios.post(this.url, {
                    path,
                    params,
                    method
                })
            },
            validationCallback,
            shouldReport
        );
    }

    get(path, params) {
        return this.call('get', path, params);
    }

    post(path, params, validationCallback, shouldReport) {

        return this.call('post', path, params, validationCallback, shouldReport);
    }

    delete(path, params) {
        return this.call('delete', path, params);
    }

    async handleResponse(caller, validationCallback = this.defaultValidationHandler, shouldReport = false) {
        try {
            return await caller();

        } catch (error) {
            if(error.message === 'canceled') {
                return false;
            }

            const { response } = error;
            if (response?.status === 422 || response?.status === 400) {
                validationCallback(response.data.errors);

                toast.error('Please review input', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    icon: false,
                    toastId : 'validation'
                });

                try {
                    return null;

                }catch (e) {

                }

            }

            if(response?.status === 403  || response?.status === 401) {
                toast.error('You do not have the correct permissions to perform this action.', {
                    toastId : 'permissions',
                    position: toast.POSITION.BOTTOM_CENTER,
                    icon: false,
                });
            }

            if(response?.status === 500 || response?.status === 502) {
                toast.error('There has been an error. Please contact support.', {
                    toastId : 'default',
                    position: toast.POSITION.BOTTOM_CENTER,
                    icon: false,
                });
            }

            if (window.Bugsnag !== null && window.Bugsnag !== undefined) {
                window.Bugsnag?.notify(error);
            }

            this.handleError(response);
        }
    }
}
